
<mat-tab-group style="overflow: hidden">
  <mat-tab label="Standard Widgets">
    <widget-type-menu-settings [widget]="widget"></widget-type-menu-settings>
  </mat-tab>

  <mat-tab label="Control Widgets">
    <widget-control-type-menu-settings [widget]="widget"></widget-control-type-menu-settings>
  </mat-tab>
</mat-tab-group>

<!--<widget-background-colour  [widget]="widget"></widget-background-colour>-->
<div  class="widgetMenuSettings-container">
  <ng-container *ngIf="widget.widgetType == widgetTypes.image">
    <image-widget-menu-settings [widget]="widget"></image-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.text">
    <text-widget-menu-settings [widget]="widget"></text-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.barChart">
    <bar-chart-widget-menu-settings [widget]="widget"></bar-chart-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.lineChart">
    <line-chart-widget-menu-settings [widget]="widget"></line-chart-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.pieChart">
    <pie-chart-widget-menu-settings [widget]="widget"></pie-chart-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.fuelGauge">
    <fuel-gauge-chart-widget-menu-settings [widget]="widget"></fuel-gauge-chart-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.textControl">
    <text-input-control-widget-menu-settings [widget]="widget"></text-input-control-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.numberControl">
    <number-input-control-widget-menu-settings [widget]="widget"></number-input-control-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.dateTimeControl">
    <datetime-input-control-widget-menu-settings [widget]="widget"></datetime-input-control-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.autoCompleteControl">
    <autocomplete-input-control-widget-menu-settings [widget]="widget"></autocomplete-input-control-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.eveUserAutoCompleteControl">
    <eve-user-autocomplete-input-control-widget-menu-settings [widget]="widget"></eve-user-autocomplete-input-control-widget-menu-settings>
  </ng-container>

  <ng-container *ngIf="widget.widgetType == widgetTypes.functionNumberAutoCompleteControl">
    <function-number-autocomplete-input-control-widget-menu-settings [widget]="widget"></function-number-autocomplete-input-control-widget-menu-settings>
  </ng-container>


</div>
